export default "__VITE_ASSET__mN1BSa8i__"